<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>

@if (alertSucesso === true) {
  <div class="body-senha">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/success.png" alt="mensagem de sucesso" width="82px">
      <p class="titulo-alert mt-4"> {{ alertSucessoSubtitulo }} </p>
      <div class="footer-alert">
        <p class="subtitulo-alert"> {{ alertSucessoMensagem }} </p>
        <button class="botao-secundario-outline mt-3" (click)="fecharAlertSucesso()">SAIR</button>
      </div>
    </div>
  </div>
}

@if (erro) {
  <div class="body-senha">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/error.png" alt="Erro" width="82px">
      <p class="titulo-alert-erro mt-4 c-danger"> {{ alertErroSubtitulo }}
      </p>
      <div class="footer-alert bg-danger">
        <p class="subtitulo-alert"> {{ alertErroMensagem }} </p>
        <button class="btn-borda-branca btn-font-branco btn-grande-vermelho mt-3"
        (click)="fecharAlertErro()">SAIR</button>
      </div>
    </div>
  </div>
}

<div class="container py-4">
  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-lg-12 mb-4 mb-lg-0">
      <div class="card altura-card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Painel de Importações</h1>
        <h4 class="paragrafo-card mb-5">Ferramenta para migrar os dados da folha de pagamento</h4>

        <table class="table table-hover border-bottom" aria-describedby="tabela que exibe as ultimas importacoes" >
          <thead>
            <tr>

              <th scope="col">Razão Social </th>
              <th scope="col">CNPJ</th>
              <th scope="col">Quantidade de usuários para atualizar</th>

            </tr>
          </thead>
          <tbody>
            <!-- LINHA 1 -->
            <tr>
              <td>{{importarDadosBancariosService.ImportacaoDadosBancariosVO?.response.razaoSocial}}
              </td>
              <td>{{$safeNavigationMigration(importarDadosBancariosService.ImportacaoDadosBancariosVO?.response.cnpj) | cnpj}}</td>
              <td>{{importarDadosBancariosService.ImportacaoDadosBancariosVO?.response.importacaoDadosBancarios.usuarios.length}}
              </td>

            </tbody>
          </table>

          <div class="text-center">
            <button class="botao-outline me-3 mt-4" routerLink='/importar-dados-bancarios'>CANCELAR</button>
            <button class="btn-grande" (click)='enviarDadosSalvar()'>CONCLUIR</button>
          </div>



        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
